// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media (min-width: 600px) and (max-width: 800px) {
    .flex-container {
      flex-wrap: wrap;
    }
}
.filter-red {
  filter: invert(21%) sepia(100%) saturate(7414%) hue-rotate(359deg) brightness(94%) contrast(118%);
}

.filter-white {
  filter: invert(100%) sepia(0%) saturate(0%) hue-rotate(93deg) brightness(103%) contrast(103%);
}`, "",{"version":3,"sources":["webpack://./src/Components/SingleProduct/product.css"],"names":[],"mappings":"AAAA;IACI;MACE,eAAe;IACjB;AACJ;AACA;EACE,iGAAiG;AACnG;;AAEA;EACE,6FAA6F;AAC/F","sourcesContent":["@media (min-width: 600px) and (max-width: 800px) {\n    .flex-container {\n      flex-wrap: wrap;\n    }\n}\n.filter-red {\n  filter: invert(21%) sepia(100%) saturate(7414%) hue-rotate(359deg) brightness(94%) contrast(118%);\n}\n\n.filter-white {\n  filter: invert(100%) sepia(0%) saturate(0%) hue-rotate(93deg) brightness(103%) contrast(103%);\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
